// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--PJnny","title":"a10a3f92e9--title--UEAG3","link":"a10a3f92e9--link--qYr1G","label":"a10a3f92e9--label--xFwJf"};